import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';

import App from '../contexts/app';
import ClinicalData from '../contexts/clinicalData';
import User from '../contexts/user';

const CustomRoute = ({ component: Component, signinRequired, clinicalPhotoRequired, availableOffline, ...rest }) => {
  return (
    <Route {...rest} render={(props) => (
      <App.Consumer>
        { (app) => (
          <User.Consumer>
            { (user) => (
              <ClinicalData.Consumer>
                {(clinicalData) => {

                  if (clinicalPhotoRequired && !clinicalData.image) {
                    return <Redirect to='/' />;
                  }

                  if (signinRequired && !user.isLoggedIn) {
                    return <Redirect to='/' />;
                  }

                  if (!availableOffline && app.isOfflineMode) {
                    return <Redirect to='/' />;
                  }

                  return ( <Component {...props} />);

                }}
              </ClinicalData.Consumer>
            )}
          </User.Consumer>
        )}
      </App.Consumer>
    )} />
  );
};

CustomRoute.defaultProps = {
  clinicalPhotoRequired: false,
  signinRequired: false,
  availableOffline: false,
};

CustomRoute.propTypes = {
  component: PropTypes.any.isRequired,
  clinicalPhotoRequired: PropTypes.bool,
  signinRequired: PropTypes.bool,
  availableOffline: PropTypes.bool
};

export default CustomRoute;
